import { WorkItem, WorkPrice } from '@work-frontend-monorepo/work-rest-api';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

export const getCurrentPriceOfItem = (item: WorkItem): WorkPrice | undefined => {
  if (!item || !item.prices || !item.prices.length) {
    return undefined;
  }
  return item.prices.filter((price) => price.active).find((price) => dayjs().isBetween(price.validFrom, price.validTo, 'day', '[]'));
};
